import { render, staticRenderFns } from "./ProjectComment.vue?vue&type=template&id=940e18ac&"
import script from "./ProjectComment.vue?vue&type=script&lang=js&"
export * from "./ProjectComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports